import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/eye-closed.svg")